export default {"src":"/_next/static/media/google.5aa2aee7.svg","height":23,"width":22};